var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uploadFile", class: { uploadBtn: _vm.source == "file" } },
    [
      _vm.canDel
        ? _c("i", {
            staticClass: "el-icon el-icon-delete",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.deletePic($event)
              },
            },
          })
        : _vm._e(),
      _c(
        "el-upload",
        {
          ref: "upload",
          class: ["avatar-uploader", _vm.deletePadding && "delete-padding"],
          attrs: {
            "before-upload": _vm.beforeAvatarUpload,
            "http-request": _vm.uploadFile,
            "show-file-list": _vm.source == "saleCallLog" ? true : false,
            disabled: _vm.disabled,
            multiple: _vm.multiple,
            "on-change": _vm.handleChange,
            accept: _vm.allowType,
            "on-remove": _vm.handleRemove,
            "on-preview": _vm.handlePreview,
            "file-list": _vm.fileList,
            action: "",
            limit: _vm.limit,
            "on-exceed": _vm.handleExceed,
          },
        },
        [
          _vm.source == "saleCallLog" || _vm.source == "file"
            ? [
                _c(
                  "el-button",
                  { attrs: { disabled: _vm.disabled, type: "primary" } },
                  [
                    _vm._v("上传文件"),
                    _c("i", { staticClass: "el-icon-upload el-icon--right" }),
                  ]
                ),
              ]
            : [
                _vm.img_url
                  ? _c("el-image", {
                      staticClass: "upload-img",
                      attrs: { src: _vm.img_url, fit: "contain" },
                    })
                  : _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon",
                    }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }